import React from 'react';
import { Award, ChatLeftHeartFill, PeopleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Space, Button } from 'antd';

import { openInNewTab } from '@/helpers';
import { useGetCommunityUrlQuery, useGetCourseQuery } from '@/services/course';
import styled, { StyledProp, css } from '@/styled';

const Integrations = ({ className }: StyledProp) => {
  const { hash } = useParams<{ hash: string }>();
  const course = useGetCourseQuery(hash);
  const community = useGetCommunityUrlQuery(hash, { skip: !course.data?.have_active_community });

  if (!course.data?.secretary_status && !course.data?.have_active_community) {
    return null;
  }

  return (
    <Space className={className} size={8} direction='vertical'>
      {course.data?.depoimentu_url && (
        <Button
          icon={<ChatLeftHeartFill />}
          className='iconButton'
          type='ghost'
          onClick={() => openInNewTab(course.data?.depoimentu_url)}
        >
          Depoimentus
        </Button>
      )}
      {course.data?.secretary_status && (
        <Button
          icon={<Award />}
          className='iconButton'
          type='ghost'
          onClick={() => openInNewTab(course.data?.secretary_url)}
        >
          Secretaria
        </Button>
      )}
      {course.data?.have_active_community && (
        <Button icon={<PeopleFill />} className='iconButton' type='ghost' onClick={() => openInNewTab(community.data)}>
          Comunidade
        </Button>
      )}
    </Space>
  );
};

export default styled(Integrations)(
  ({ theme }) => css`
    .ant-space {
      margin-left: ${theme.space.pxToRem(24)};
    }

    .ant-space-item {
      display: flex;
      justify-content: center;
    }

    .iconButton {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      background: ${theme.variables.integrationButton.background};
      width: calc(100% - 48px);
      height: ${theme.space.pxToRem(32)};
      border: ${theme.variables.integrationButton.border} 1px solid;
      span,
      svg {
        color: ${theme.variables.integrationButton.text};
      }
    }
  `
);
